<!-- 商品卡片组件 -->
<template>
    <div :class="isActive ? 'member-card member-card-active' : 'member-card'">
        <div v-if="discountTxt" class="discount-info">{{ discountTxt }}</div>
        <div class="card-content">
            <div class="name">{{ name }}</div>
            <div class="show-price">
                {{ showPricePrefix }}¥<span class="light-num">{{
                    showPrice / 100
                }}</span>/{{ goodsType === "half_year" ? "半年" : "年" }}
            </div>
            <div v-if="discountTxt" class="origin-price">
                ¥{{ originPrice / 100 }}
            </div>
        </div>
    </div>
</template>

<script>
/**
 * @file goodsCard.vue
 * @desc 商品卡片
 * @author dingzhenyue
 */
export default {
    props: {
        // 折扣文案
        discountTxt: {
            type: String,
            default: ''
        },
        // 原始价格
        originPrice: {
            type: Number,
            default: 0
        },
        // 商品名称
        name: {
            type: String,
            default: ''
        },
        // 展示的价格
        showPricePrefix: {
            type: String,
            default: ''
        },
        // 展示的价格
        showPrice: {
            type: Number,
            default: 0
        },
        // 是否选中态
        isActive: {
            type: Boolean,
            default: true
        },
        goodsType: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang='less' scoped>
.member-card {
    min-width: 145px;
    padding: 0 20px;
    height: 91px;
    background-image: linear-gradient(270deg, #fadfa8 0%, #f4c787 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background: #ffffff;
    border: 1px solid rgba(226, 230, 240, 1);
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;

    .discount-info {
        width: 68px;
        height: 18px;
        line-height: 18px;
        font-size: 12px;
        color: #ffffff;
        position: absolute;
        left: -1px;
        top: -9px;
        text-align: center;
        text-indent: 6px;
        background-image: linear-gradient(90deg, #f67384 0%, #e64552 100%);
        border-radius: 6px 0px 6px 0px;
    }

    .card-content {
        width: 100%;
        height: 100%;
        align-items: center;
        text-align: center;

        .name {
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #000000;
            text-align: center;
            font-weight: 500;
            margin-top: 16px;
        }
    }

    .show-price {
        height: 24px;
        line-height: 24px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #0052cc;
        line-height: 24px;
        font-weight: 500;
        margin-top: 8px;

        .light-num {
            font-size: 24px;
        }
    }

    .origin-price {
        height: 17px;
        line-height: 17px;
        font-size: 12px;
        color: #848b99;
        margin-top: 2px;
        text-decoration: line-through;
    }
}

.member-card-active {
    position: relative;
    background: #f0f6ff;
    border: 1px solid rgba(0, 82, 204, 1);
}
</style>
